module.exports = __webpack_public_path__ + "static/media/hotbid-one.8cbb6eb2.png";